// What a mark on the whiteboard may be — one set of rules for every screen and for the studio's store (Canvas stage
// 10; context/21-canvas-whiteboard.md). The browser's canvas/ink.js re-exports these, and /api/ink checks every stroke
// it keeps against the same function, so what a phone refuses and what the store refuses cannot drift apart.
export const TOOLS = ["pen", "hl", "arrow", "label", "laser"];
// pagePoints: all the points on one page together — a page of 300 long strokes would be megabytes, too big to keep.
export const LIMITS = { points: 2000, strokes: 300, label: 60, id: 40, pages: 60, boards: 20, stills: 20, stream: 65536, pagePoints: 60000 };
export const UNITS = 10000; // 100% in hundredths of a percent

// A stroke as it may be trusted: anything malformed, oversized or of an unknown tool is refused whole.
export function cleanStroke(s) {
  if (!s || typeof s !== "object") return null;
  const id = typeof s.id === "string" ? s.id.slice(0, LIMITS.id) : "";
  if (!id || !TOOLS.includes(s.tool)) return null;
  if (!Array.isArray(s.pts) || s.pts.length < 1 || s.pts.length > LIMITS.points) return null;
  const pts = [];
  for (const p of s.pts) {
    if (!Array.isArray(p) || p.length !== 2 || !Number.isFinite(p[0]) || !Number.isFinite(p[1])) return null;
    pts.push([Math.max(0, Math.min(UNITS, Math.round(p[0]))), Math.max(0, Math.min(UNITS, Math.round(p[1])))]);
  }
  const out = { id, tool: s.tool, pts, by: typeof s.by === "string" ? s.by.slice(0, 80) : "" };
  if (s.tool === "label") {
    const text = typeof s.text === "string" ? s.text.replace(/\s+/g, " ").trim().slice(0, LIMITS.label) : "";
    if (!text) return null;
    out.text = text;
    out.pts = pts.slice(0, 1);
  }
  if (s.tool === "arrow") {
    if (pts.length < 2) return null;
    out.pts = [pts[0], pts[pts.length - 1]];
  }
  return out;
}

// The shape of a page that keeps ink, for the store, which has no canvas to look scenes up in: a board or a still by
// number, or a scene (and a plan's unit) by its id. "share" — the glass over a live tab or the site camera — is never
// kept: its marks belong to that picture only. The screens check a page against the canvas itself (ink.js pageOk).
export function storedPageOk(key) {
  if (typeof key !== "string" || key.length > 80 || key === "share") return false;
  // "board" and "still" are only ever numbered pages: "still:0" or "board:01" is not a scene with a unit.
  if (/^(board|still)(:|$)/.test(key)) {
    const n = /^(board|still):([1-9]\d?)$/.exec(key);
    return Boolean(n) && +n[2] <= (n[1] === "board" ? LIMITS.boards : LIMITS.stills);
  }
  return /^[a-z0-9][a-z0-9-]{0,39}(:[a-z0-9][a-z0-9-]{0,39})?$/.test(key);
}
